import OrderDelivery from './OrderDelivery';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import reduce from 'lodash/reduce';
import withGlobalContent from '../../../hocs/withGlobalContent';
import withCountry from '../../../hocs/withCountry';
import dateTimeFormatter from 'src/common/utils/date-time-formatter';

const enhance = compose(
  withCountry,
  withGlobalContent,
  withProps(({ globalContent: { orders }, delivery, country }) => ({
    label: orders.deliveryDateLabel,
    delivery: reduce(delivery, (result, value, key) => {
      result[key] = dateTimeFormatter.date(value, country, {
        month: 'long',
        day: 'numeric'
      });
      return result;
    }, {})
  })),
);

export default enhance(OrderDelivery);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderDelivery/index.js